export const getShareKey = () => {
  const location = window.location
  return location.pathname.match(/\/output\/(\w+)/)?.[1] || ''
}
